import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

const ManageAccountSubmitButton = ({ label, disabled }) => {
  return (
    <Stack direction={{ xs: "column", sm: "row" }} justifyContent={"space-evenly"} mt={3}>
      <Button
        variant="contained"
        size="small"
        type="submit"
        sx={{ marginTop: "15px" }}
        disabled={!!disabled}
      >
        {label}
      </Button>
    </Stack>
  );
};

export default ManageAccountSubmitButton;
